/* ============================================================================
FILE: po-katupirsia5-ekuphasa-texts-fr-en-es-20260312.js

MODE: TRILINGUE (FR/EN/ES) + protection lexicale stricte
API:  window.PoK5EkuphasaTextsFR_EN_ES_20260312
ROOT: .po-k5-section[data-po-k5]

RÔLE:
- injecte le contenu FR/EN/ES dans les slots data-po-slot
- conserve les termes du lexique canonique en FR, quelle que soit la langue
- verrouille la traduction automatique sur le bloc
- compat Shopify / multi-instances
- alias compat : window.GoodyTwinLang
- ajoute une couche audio locale et générale sans toucher au socle multilingue,
  au nom du fichier, ni aux protections lexicales.
============================================================================ */

(function () {
  "use strict";

  if (window.__PO_K5_EKUPHASA_TEXTS_20260312__) return;
  window.__PO_K5_EKUPHASA_TEXTS_20260312__ = true;
  window.__POLEX_RUNTIME_INIT__ = true;

  var STORAGE_KEY = "po_lex_lang";
  var STORAGE_KEY_COMPAT = "goody_gp_lang";
  var ROOT_SEL = '.po-k5-section[data-po-k5="ekuphasa"]';

  function clampStr(v) {
    return v == null ? "" : String(v);
  }

  function normLang(raw) {
    var v = clampStr(raw).toLowerCase().trim();
    if (v.indexOf("fr") === 0) return "fr";
    if (v.indexOf("en") === 0) return "en";
    if (v.indexOf("es") === 0) return "es";
    return "";
  }

  function readStoredLang() {
    try {
      var v = normLang(localStorage.getItem(STORAGE_KEY));
      if (v) return v;
    } catch (e) {}
    try {
      var v2 = normLang(localStorage.getItem(STORAGE_KEY_COMPAT));
      if (v2) return v2;
    } catch (e) {}
    return "";
  }

  function storeLang(lang) {
    var v = normLang(lang) || "fr";
    try { localStorage.setItem(STORAGE_KEY, v); } catch (e) {}
    try { localStorage.setItem(STORAGE_KEY_COMPAT, v); } catch (e) {}
    try { document.documentElement.setAttribute("lang", v); } catch (e) {}
    return v;
  }

  function detectBrowserLang() {
    try {
      var n = (navigator && (navigator.language || (navigator.languages && navigator.languages[0]))) || "";
      var v = normLang(n);
      if (v) return v;
    } catch (e) {}
    return "fr";
  }

  function getLang() {
    return readStoredLang() || detectBrowserLang() || "fr";
  }

  function notifyLocaleChanged() {
    try {
      window.dispatchEvent(new Event("po:locale-changed"));
    } catch (e) {
      try {
        var ev = document.createEvent("Event");
        ev.initEvent("po:locale-changed", true, true);
        window.dispatchEvent(ev);
      } catch (_e) {}
    }
  }

  function escapeRegExp(s) {
    return String(s).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }

  function uniqPush(arr, v) {
    if (!v) return;
    for (var i = 0; i < arr.length; i++) {
      if (arr[i] === v) return;
    }
    arr.push(v);
  }

  function buildVariants(term) {
    var out = [];
    var t = clampStr(term);
    if (!t) return out;

    uniqPush(out, t);
    uniqPush(out, t.replace(/’/g, "'"));
    uniqPush(out, t.replace(/'/g, "’"));
    uniqPush(out, t.replace(/œ/g, "oe").replace(/Œ/g, "OE"));
    uniqPush(out, t.replace(/oe/g, "œ").replace(/OE/g, "Œ"));

    var oe1 = t.replace(/œ/g, "oe").replace(/Œ/g, "OE");
    var oe2 = t.replace(/oe/g, "œ").replace(/OE/g, "Œ");
    uniqPush(out, oe1.replace(/’/g, "'"));
    uniqPush(out, oe1.replace(/'/g, "’"));
    uniqPush(out, oe2.replace(/’/g, "'"));
    uniqPush(out, oe2.replace(/'/g, "’"));

    return out;
  }

  function getSimplifiedLexiqueFRList() {
    try {
      if (window.PO_LEXICON_META && Array.isArray(window.PO_LEXICON_META.lexique_simplifie_fr)) {
        return window.PO_LEXICON_META.lexique_simplifie_fr.slice();
      }
    } catch (e) {}
    try {
      if (window.PO_LEXICON && window.PO_LEXICON.meta && Array.isArray(window.PO_LEXICON.meta.lexique_simplifie_fr)) {
        return window.PO_LEXICON.meta.lexique_simplifie_fr.slice();
      }
    } catch (e) {}

    return [
      "Posœnnoïa",
      "Posœnnoïsme",
      "Organon posœnnoïal",
      "Katûvýs",
      "Katûvýsissence",
      "Isqun",
      "Threnisqun",
      "Sceau d’Équiphase",
      "Ēkuphasa",
      "RéZonans",
      "Tiqqunbahu",
      "Takimarah",
      "Katûvýsqun",
      "Posœnnomia",
      "Méditations posœnnoïales",
      "Temporalité élargie",
      "Temporalité éclatée",
      "Conscientisation dynamique",
      "Souffle d’Ékuphase"
    ];
  }

  function buildProtectMatcher() {
    var base = getSimplifiedLexiqueFRList();
    var variants = [];

    for (var i = 0; i < base.length; i++) {
      var list = buildVariants(base[i]);
      for (var j = 0; j < list.length; j++) uniqPush(variants, list[j]);
    }

    variants.sort(function (a, b) { return b.length - a.length; });

    var parts = [];
    for (var k = 0; k < variants.length; k++) parts.push(escapeRegExp(variants[k]));
    return new RegExp(parts.join("|"), "g");
  }

  var __PO_PROTECT_RE__ = null;

  function protectLexiconInHTML(html) {
    var src = clampStr(html);
    if (!src) return "";

    if (!__PO_PROTECT_RE__) __PO_PROTECT_RE__ = buildProtectMatcher();

    var out = src.replace(__PO_PROTECT_RE__, function (m) {
      return '<span translate="no" class="po-lex-protect">' + m + "</span>";
    });

    out = out.replace(/([0-9A-Za-zÀ-ÖØ-öø-ÿ])(<span translate="no" class="po-lex-protect">)/g, "$1 $2");
    out = out.replace(/(<\/span>)([0-9A-Za-zÀ-ÖØ-öø-ÿ])/g, "$1 $2");
    out = out.replace(/(<\/span>)(<[^\/\s>])/g, "$1 $2");
    out = out.replace(/([^\s>])(<span translate="no" class="po-lex-protect">)/g, function (_m, a, b) {
      if (a === " " || a === ">") return a + b;
      return a + " " + b;
    });

    return out;
  }

  function setHTML(el, html) {
    if (!el) return;
    el.innerHTML = protectLexiconInHTML(html);
  }

  function setText(el, txt) {
    if (!el) return;
    el.textContent = clampStr(txt);
  }

  function setImg(el, data) {
    if (!el) return;
    var src = data && data.src ? data.src : "";
    var alt = data && data.alt ? data.alt : "";
    if (src) {
      el.src = src;
      el.alt = alt;
      el.removeAttribute("hidden");
      try { el.style.display = ""; } catch (e) {}
    } else {
      el.setAttribute("hidden", "");
      try { el.style.display = "none"; } catch (e) {}
    }
  }

  /* --------------------------------------------------------------------------
   * AUDIO LOCAL PAR BLOC + TEXTE GÉNÉRAL
   * -------------------------------------------------------------------------- */

  var PO_AUDIO_SYNTH = (typeof window !== "undefined" && window.speechSynthesis) ? window.speechSynthesis : null;
  var PO_AUDIO_STATE = {
    root: null,
    units: [],
    unitPos: -1,
    chunks: [],
    chunkPos: -1,
    activeKey: "",
    lang: "fr",
    voice: null
  };

  var AUDIO_UI = {
    fr: { general: "Écouter le texte", block: "Écouter ce bloc", stop: "Arrêter la lecture" },
    en: { general: "Listen to the text", block: "Listen to this section", stop: "Stop playback" },
    es: { general: "Escuchar el texto", block: "Escuchar este bloque", stop: "Detener la lectura" }
  };

  function audioUI(lang) {
    return AUDIO_UI[normLang(lang)] || AUDIO_UI.fr;
  }

  function getAudioRoots() {
    try { return document.querySelectorAll(ROOT_SEL); } catch (e) { return []; }
  }

  function getDetailBlocks(root) {
    try { return root.querySelectorAll(".po-lex-details"); } catch (e) { return []; }
  }

  function ensureAudioStyles() {
    if (document.getElementById("po-k5-audio-styles")) return;
    var style = document.createElement("style");
    style.id = "po-k5-audio-styles";
    style.textContent =
      ".po-axis-audio-wrap{display:flex;align-items:center;gap:.6rem;margin:1rem 0 1.15rem 0;justify-content:flex-start;}" +
      ".po-axis-audio-btn{appearance:none;-webkit-appearance:none;border:1px solid rgba(184,134,11,.55);background:rgba(31,122,58,.04);color:var(--color-accent,#1f7a3a);padding:.55rem .9rem;border-radius:999px;cursor:pointer;font:inherit;font-weight:800;line-height:1.2;transition:opacity .2s ease,transform .2s ease,box-shadow .2s ease,border-color .2s ease;box-shadow:0 6px 16px rgba(31,122,58,.10);}" +
      ".po-axis-audio-btn:hover{transform:translateY(-1px);box-shadow:0 10px 26px rgba(31,122,58,.16);border-color:rgba(184,134,11,.75);}" +
      ".po-axis-audio-btn[aria-pressed='true']{box-shadow:0 0 0 1px rgba(184,134,11,.18),0 10px 26px rgba(31,122,58,.18);background:rgba(31,122,58,.08);}" +
      ".po-lex-summary .po-axis-audio-btn{margin-left:.75rem;vertical-align:middle;flex:0 0 auto;}" +
      "@media (max-width:640px){.po-lex-summary{flex-wrap:wrap;}.po-lex-summary .po-axis-audio-btn{display:block;margin:.65rem 0 0 0;}}";
    document.head.appendChild(style);
  }

  function createAudioButton(role) {
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "po-axis-audio-btn";
    btn.setAttribute("data-po-audio-role", role === "general" ? "general" : "detail");
    btn.setAttribute("aria-pressed", "false");
    btn.setAttribute("translate", "yes");
    return btn;
  }

  function ensureAudioButtons(root) {
    if (!root) return;
    ensureAudioStyles();

    var panel = root.querySelector(".po-lex-panel");
    if (panel) {
      var generalWrap = root.querySelector('.po-axis-audio-wrap[data-po-audio-role="general"]');
      if (!generalWrap) {
        generalWrap = document.createElement("div");
        generalWrap.className = "po-axis-audio-wrap";
        generalWrap.setAttribute("data-po-audio-role", "general");
        generalWrap.appendChild(createAudioButton("general"));

        var meta = root.querySelector(".po-axis-meta");
        var defShort = root.querySelector('[data-po-slot="def_short"]');
        var firstDetail = panel.querySelector(".po-lex-details");

        if (meta && meta.parentNode) {
          if (meta.nextSibling) meta.parentNode.insertBefore(generalWrap, meta.nextSibling);
          else meta.parentNode.appendChild(generalWrap);
        } else if (defShort && defShort.parentNode) {
          defShort.parentNode.insertBefore(generalWrap, defShort);
        } else if (firstDetail && firstDetail.parentNode) {
          firstDetail.parentNode.insertBefore(generalWrap, firstDetail);
        } else {
          panel.appendChild(generalWrap);
        }
      }
    }

    var details = getDetailBlocks(root);
    for (var i = 0; i < details.length; i++) {
      var summary = details[i].querySelector(".po-lex-summary");
      if (!summary) continue;
      var btn = summary.querySelector('.po-axis-audio-btn[data-po-audio-role="detail"]');
      if (!btn) {
        btn = createAudioButton("detail");
        summary.appendChild(btn);
      }
      btn.setAttribute("data-po-audio-index", String(i));
    }
  }

  function getTextValue(el) {
    if (!el) return "";
    var txt = "";
    try { txt = el.innerText || el.textContent || ""; } catch (e) { txt = ""; }
    return clampStr(txt).replace(/\s+/g, " ").trim();
  }

  function removeAudioButtonsFromClone(root) {
    if (!root || !root.querySelectorAll) return;
    var btns = root.querySelectorAll(".po-axis-audio-wrap, .po-axis-audio-btn");
    for (var i = 0; i < btns.length; i++) {
      if (btns[i] && btns[i].parentNode) btns[i].parentNode.removeChild(btns[i]);
    }
  }

  function collectGeneralText(root) {
    var parts = [];
    var slots = ["title", "kicker", "h_def", "def_short", "def_long"];
    for (var i = 0; i < slots.length; i++) {
      var el = root.querySelector('[data-po-slot="' + slots[i] + '"]');
      var txt = getTextValue(el);
      if (txt) parts.push(txt);
    }
    return parts.join(". ");
  }

  function collectDetailText(detail) {
    if (!detail) return "";
    var parts = [];
    var title = detail.querySelector(".po-lex-summary__title");
    var titleText = getTextValue(title);
    if (titleText) parts.push(titleText);

    var clone = detail.cloneNode(true);
    var summary = clone.querySelector(".po-lex-summary");
    if (summary && summary.parentNode) summary.parentNode.removeChild(summary);
    removeAudioButtonsFromClone(clone);

    var bodyText = getTextValue(clone);
    if (bodyText) parts.push(bodyText);
    return parts.join(". ");
  }

  function splitTextForSpeech(text) {
    var raw = clampStr(text).replace(/\s+/g, " ").trim();
    if (!raw) return [];
    var pieces = raw.match(/[^.!?;:]+[.!?;:]?/g) || [raw];
    var out = [];
    var current = "";
    for (var i = 0; i < pieces.length; i++) {
      var piece = clampStr(pieces[i]).trim();
      if (!piece) continue;
      if (((current ? current + " " : "") + piece).length > 220) {
        if (current) out.push(current.trim());
        if (piece.length > 220) {
          var words = piece.split(/\s+/);
          var acc = "";
          for (var j = 0; j < words.length; j++) {
            var w = words[j];
            if (!w) continue;
            var next = acc ? (acc + " " + w) : w;
            if (next.length > 220) {
              if (acc) out.push(acc.trim());
              acc = w;
            } else acc = next;
          }
          current = acc || "";
        } else current = piece;
      } else current = current ? (current + " " + piece) : piece;
    }
    if (current) out.push(current.trim());
    return out;
  }

  function getVoices() {
    try { return PO_AUDIO_SYNTH ? (PO_AUDIO_SYNTH.getVoices() || []) : []; } catch (e) { return []; }
  }

  function pickVoiceForLang(lang) {
    var voices = getVoices();
    if (!voices.length) return null;
    var target = normLang(lang);
    var targets = (target === "fr") ? ["fr", "fr-fr", "fr_ca", "fr-ca"] : (target === "en") ? ["en", "en-us", "en-gb"] : ["es", "es-es", "es-mx", "es-us"];
    var i, v, vl;
    for (i = 0; i < voices.length; i++) { v = voices[i]; vl = clampStr(v.lang).toLowerCase(); if (targets.indexOf(vl) !== -1) return v; }
    for (i = 0; i < voices.length; i++) { v = voices[i]; vl = clampStr(v.lang).toLowerCase(); if (vl.indexOf(target) === 0) return v; }
    return voices[0] || null;
  }

  function getSpeechLangCode(lang) {
    var L = normLang(lang);
    if (L === "en") return "en-US";
    if (L === "es") return "es-ES";
    return "fr-FR";
  }

  function buildUnits(root, role, index) {
    var details = getDetailBlocks(root);
    var units = [];
    if (role === "general") {
      units.push({ role: "general", index: -1 });
      for (var i = 0; i < details.length; i++) units.push({ role: "detail", index: i });
      return units;
    }
    var start = (typeof index === "number" && index >= 0) ? index : 0;
    for (var j = start; j < details.length; j++) units.push({ role: "detail", index: j });
    return units;
  }

  function updateAudioPressedState() {
    var roots = getAudioRoots();
    for (var i = 0; i < roots.length; i++) {
      var btns = roots[i].querySelectorAll(".po-axis-audio-btn");
      for (var j = 0; j < btns.length; j++) btns[j].setAttribute("aria-pressed", "false");
    }

    if (!PO_AUDIO_STATE.root || !PO_AUDIO_STATE.activeKey) return;

    var btn;
    if (PO_AUDIO_STATE.activeKey === "general") {
      btn = PO_AUDIO_STATE.root.querySelector('.po-axis-audio-wrap[data-po-audio-role="general"] .po-axis-audio-btn[data-po-audio-role="general"]');
      if (btn) btn.setAttribute("aria-pressed", "true");
      return;
    }

    var idx = parseInt(String(PO_AUDIO_STATE.activeKey).split(":")[1], 10);
    if (!isNaN(idx)) {
      btn = PO_AUDIO_STATE.root.querySelector('.po-axis-audio-btn[data-po-audio-role="detail"][data-po-audio-index="' + idx + '"]');
      if (btn) btn.setAttribute("aria-pressed", "true");
    }
  }

  function refreshAudioLabels(root, lang) {
    if (!root) return;
    var ui = audioUI(lang || getLang());

    var generalBtn = root.querySelector('.po-axis-audio-wrap[data-po-audio-role="general"] .po-axis-audio-btn[data-po-audio-role="general"]');
    if (generalBtn) {
      var generalActive = (PO_AUDIO_STATE.root === root && PO_AUDIO_STATE.activeKey === "general" && PO_AUDIO_SYNTH && (PO_AUDIO_SYNTH.speaking || PO_AUDIO_SYNTH.pending));
      generalBtn.textContent = generalActive ? ui.stop : ui.general;
    }

    var detailBtns = root.querySelectorAll('.po-axis-audio-btn[data-po-audio-role="detail"]');
    for (var i = 0; i < detailBtns.length; i++) {
      var btn = detailBtns[i];
      var idx = parseInt(btn.getAttribute("data-po-audio-index"), 10);
      var key = "detail:" + (isNaN(idx) ? -1 : idx);
      var active = (PO_AUDIO_STATE.root === root && PO_AUDIO_STATE.activeKey === key && PO_AUDIO_SYNTH && (PO_AUDIO_SYNTH.speaking || PO_AUDIO_SYNTH.pending));
      btn.textContent = active ? ui.stop : ui.block;
    }

    updateAudioPressedState();
  }

  function refreshAllAudioLabels(lang) {
    var roots = getAudioRoots();
    for (var i = 0; i < roots.length; i++) refreshAudioLabels(roots[i], lang || getLang());
  }

  function stopAudio(silent) {
    if (PO_AUDIO_SYNTH) {
      try { PO_AUDIO_SYNTH.cancel(); } catch (e) {}
    }
    PO_AUDIO_STATE.root = null;
    PO_AUDIO_STATE.units = [];
    PO_AUDIO_STATE.unitPos = -1;
    PO_AUDIO_STATE.chunks = [];
    PO_AUDIO_STATE.chunkPos = -1;
    PO_AUDIO_STATE.activeKey = "";
    PO_AUDIO_STATE.lang = "fr";
    PO_AUDIO_STATE.voice = null;
    if (silent) updateAudioPressedState();
    else refreshAllAudioLabels(getLang());
  }

  function speakCurrentChunk() {
    if (!PO_AUDIO_SYNTH) return;

    if (!PO_AUDIO_STATE.chunks.length || PO_AUDIO_STATE.chunkPos < 0 || PO_AUDIO_STATE.chunkPos >= PO_AUDIO_STATE.chunks.length) {
      PO_AUDIO_STATE.unitPos += 1;
      playCurrentUnit(true);
      return;
    }

    var txt = PO_AUDIO_STATE.chunks[PO_AUDIO_STATE.chunkPos];
    if (!txt) {
      PO_AUDIO_STATE.chunkPos += 1;
      speakCurrentChunk();
      return;
    }

    var utter = new SpeechSynthesisUtterance(txt);
    utter.lang = getSpeechLangCode(PO_AUDIO_STATE.lang || getLang());
    if (PO_AUDIO_STATE.voice) utter.voice = PO_AUDIO_STATE.voice;

    utter.onend = function () {
      PO_AUDIO_STATE.chunkPos += 1;
      speakCurrentChunk();
    };
    utter.onerror = function () {
      PO_AUDIO_STATE.chunkPos += 1;
      speakCurrentChunk();
    };

    try { PO_AUDIO_SYNTH.speak(utter); } catch (e) {
      PO_AUDIO_STATE.chunkPos += 1;
      speakCurrentChunk();
    }
  }

  function playCurrentUnit(skipCancel) {
    if (!PO_AUDIO_SYNTH) return;
    if (!skipCancel) {
      try { PO_AUDIO_SYNTH.cancel(); } catch (e) {}
    }

    if (!PO_AUDIO_STATE.root || PO_AUDIO_STATE.unitPos < 0 || PO_AUDIO_STATE.unitPos >= PO_AUDIO_STATE.units.length) {
      stopAudio();
      return;
    }

    var unit = PO_AUDIO_STATE.units[PO_AUDIO_STATE.unitPos];
    if (!unit) {
      stopAudio();
      return;
    }

    var text = "";
    if (unit.role === "general") {
      PO_AUDIO_STATE.activeKey = "general";
      text = collectGeneralText(PO_AUDIO_STATE.root);
    } else {
      PO_AUDIO_STATE.activeKey = "detail:" + unit.index;
      var details = getDetailBlocks(PO_AUDIO_STATE.root);
      var detail = details[unit.index];
      if (detail) {
        try { detail.open = true; } catch (e) {}
      }
      text = collectDetailText(detail);
    }

    PO_AUDIO_STATE.chunks = splitTextForSpeech(text);
    PO_AUDIO_STATE.chunkPos = 0;
    refreshAllAudioLabels(PO_AUDIO_STATE.lang || getLang());

    if (!PO_AUDIO_STATE.chunks.length) {
      PO_AUDIO_STATE.unitPos += 1;
      playCurrentUnit(true);
      return;
    }

    speakCurrentChunk();
  }

  function startAudio(root, role, index) {
    if (!PO_AUDIO_SYNTH || !root) return;
    stopAudio(true);
    var lang = getLang();
    PO_AUDIO_STATE.root = root;
    PO_AUDIO_STATE.units = buildUnits(root, role, index);
    PO_AUDIO_STATE.unitPos = 0;
    PO_AUDIO_STATE.chunks = [];
    PO_AUDIO_STATE.chunkPos = -1;
    PO_AUDIO_STATE.activeKey = "";
    PO_AUDIO_STATE.lang = lang;
    PO_AUDIO_STATE.voice = pickVoiceForLang(lang);
    refreshAllAudioLabels(lang);
    playCurrentUnit(false);
  }

  function bindAudioButtons(root) {
    if (!root) return;
    var btns = root.querySelectorAll(".po-axis-audio-btn");
    for (var i = 0; i < btns.length; i++) {
      var btn = btns[i];
      if (btn.__poAudioBound) continue;
      btn.addEventListener("click", function (ev) {
        ev.preventDefault();
        ev.stopPropagation();
        var role = this.getAttribute("data-po-audio-role") || "detail";
        var index = parseInt(this.getAttribute("data-po-audio-index"), 10);
        var key = (role === "general") ? "general" : ("detail:" + (isNaN(index) ? -1 : index));
        var sameRoot = (PO_AUDIO_STATE.root === root);
        var sameKey = (PO_AUDIO_STATE.activeKey === key);
        if (sameRoot && sameKey && PO_AUDIO_SYNTH && (PO_AUDIO_SYNTH.speaking || PO_AUDIO_SYNTH.pending)) {
          stopAudio();
          return;
        }
        startAudio(root, role, isNaN(index) ? -1 : index);
      });
      btn.__poAudioBound = true;
    }
  }

  function initAudioEverywhere(lang) {
    var roots = getAudioRoots();
    for (var i = 0; i < roots.length; i++) {
      ensureAudioButtons(roots[i]);
      bindAudioButtons(roots[i]);
      refreshAudioLabels(roots[i], lang || getLang());
    }
  }

  try {
    if (PO_AUDIO_SYNTH && typeof PO_AUDIO_SYNTH.addEventListener === "function") {
      PO_AUDIO_SYNTH.addEventListener("voiceschanged", function () {
        if (PO_AUDIO_STATE.root) PO_AUDIO_STATE.voice = pickVoiceForLang(PO_AUDIO_STATE.lang || getLang());
      });
    }
  } catch (e) {}

  var CONTENT = {
    fr: {
      title: "Ēkuphasa",
      kicker: "Émanation isqunienne du <strong>Sceau d’Équiphase</strong> — désintégration spiralée du temps excédentaire.",
      title_img: { src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Ekuphasa_copie.png?v=1772922638", alt: "Idéogramme de Ēkuphasa" },

      h_def: "Définition canonique",

      chip_1: "Entité de Threnisqun",
      chip_1_img: { src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/threnisqun_2_copie.png?v=1772883862", alt: "Icône entité Threnisqun" },
      chip_2: "Fréquence 619",
      chip_2_img: { src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Nombre_guide_619.png?v=1773414281", alt: "Icône fréquence 619" },
      chip_3: "Alignement 492 Hz",
      chip_3_img: { src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Nombre_guide_492.png?v=1773413365", alt: "Icône alignement 492 Hz" },

      def_short:
        "<strong>Ēkuphasa</strong> incarne la désintégration spiralée du temps excédentaire : elle absorbe les surplus temporels non intégrés, les redistribue en souffle stabilisant et rend le présent respirable.",

      def_long:
        "<p>Entité isqunienne émanée du <strong>Sceau d’Équiphase</strong>, <strong>Ēkuphasa</strong> agit dans le champ du <strong>Threnisqun</strong> en transformant le temps piégé — retards, instants disjoints, résidus cycliques, surcharge du passé ou de l’anticipation — en matière de régénération rythmique.</p>" +
        "<p>Elle ne corrige pas le temps par contrainte. Elle ouvre des interstices, dissout les décalages de phase et restitue une cadence habitable entre temps vécu, temps social, rythme du corps et respiration cosmique.</p>",

      h_grid: "Statut vibratoire",
      grid_type_label: "Nature",
      grid_type_value: "Entité isqunienne issue de l’activité de régulation du temps excédentaire et des décalages de phase, émanée du <strong>Sceau d’Équiphase</strong>.",
      grid_freq_label: "Fréquence d’alignement",
      grid_freq_value: "619",
      grid_scope_label: "Champ et déploiement",
      grid_scope_value:
        "<ul>" +
        "<li>Temps perdu, instants non vécus, résidus cycliques, empilements temporels</li>" +
        "<li>Zones liminaires du calendrier : intercycles, jours épagomènes, nuits sans veille</li>" +
        "<li>Redistribution du surplus en souffle stabilisant dans le champ</li>" +
        "<li>Réaccord entre temporalité humaine, sociale et cosmique</li>" +
        "</ul>",

      h_intro: "Fonction principale",
      p_intro:
        "<p><strong>Ēkuphasa</strong> absorbe les restes temporels non intégrés, les désintègre par spiralisation rituelle, puis les redistribue comme souffle. Le point décisif du corpus tient ici : le temps n’est pas réparé, il est spiralisé.</p>" +
        "<p>Son geste protège les interstices du vivant. Lorsque le passé encombre, lorsque le futur pèse sur le présent, lorsque le cycle refuse de se clore ou de s’ouvrir, elle redonne au champ une respiration praticable.</p>",

      h_actions: "Fonctions rituelles",
      actions:
        "<ol>" +
        "<li>Absorber les restes temporels : heures perdues, moments disjoints, absences non ritualisées.</li>" +
        "<li>Transformer le surplus en souffle expansif, plutôt qu’en dette ou en correction.</li>" +
        "<li>Stabiliser la temporalité humaine dans le champ cosmique.</li>" +
        "<li>Réguler les cycles dissonants : temps linéaire et temps vécu, temps social et temps du corps.</li>" +
        "<li>Préserver les interstices en ouvrant des seuils respirables dans le temps.</li>" +
        "</ol>",

      h_phrase: "Formules d’usage",
      phrase:
        "<p>« Ēkuphasa spiralise. »</p>" +
        "<p>« Ēkuphasa redistribue. »</p>" +
        "<p>« Ēkuphasa ouvre l’interstice. »</p>",

      h_table: "Tableau d’usage",
      table_head_1: "Situation",
      table_head_2: "Signe",
      table_head_3: "Action de Ēkuphasa",
      table_rows:
        "<tr><td>Temps qui déborde</td><td>Retard, empilement, sensation de strates</td><td>Spiralise le surplus et le rend respirable</td></tr>" +
        "<tr><td>Présent encombré</td><td>Passé ou futur prennent toute la place</td><td>Redistribue les charges dans un souffle stabilisant</td></tr>" +
        "<tr><td>Cycle bloqué</td><td>Impossibilité de clore ou d’ouvrir une phase</td><td>Ouvre l’interstice temporel</td></tr>" +
        "<tr><td>Temporalités dissonantes</td><td>Temps social contre rythme du corps</td><td>Réaccorde le champ sans correction forcée</td></tr>",

      h_entite: "Nom et souffle opératif",
      entite_kicker: "Ēku + phasa",
      entite_body:
        "<p>Le corpus explicite <strong>Ēkuphasa</strong> comme « ce qui libère les temps piégés par le souffle ».</p>" +
        "<p><strong>Ēku-</strong> renvoie au souffle spiralé dans le lexique posœnnoïal ; <strong>-phasa</strong> qualifie le fragment temporel pris dans un enchevêtrement. Le nom lui-même porte donc une fonction de désintrication et de redistribution respiratoire.</p>",

      h_ritual: "Rituel d’activation",
      ritual_name_label: "Nom",
      ritual_name_value: "Souffle d’Ékuphase",
      ritual_steps:
        "<ol>" +
        "<li>Se placer dans un entre-deux : fin de journée, veille, attente, bord de cycle.</li>" +
        "<li>Reconnaître le trop-plein de passé, le retard, l’empilement ou la dissociation temporelle.</li>" +
        "<li>Pratiquer une expiration silencieuse en spirale.</li>" +
        "<li>Visualiser un souffle noir puis argenté s’élevant du cœur jusqu’à l’espace céleste.</li>" +
        "<li>Au besoin, soutenir le geste par un gong ou un souffle en trois temps : 3–6–9 secondes.</li>" +
        "</ol>",

      h_moments: "Moments privilégiés",
      moments:
        "<ul>" +
        "<li>Entre deux cycles : mois, années, jours</li>" +
        "<li>Pendant une suspension temporelle : retard, attente, veille</li>" +
        "<li>Lorsque le corps ressent un trop-plein de passé non digéré</li>" +
        "<li>Dans les zones liminaires du calendrier et les intercycles</li>" +
        "</ul>",

      h_syntony: "Syntonies Katûvýsiennes",
      syntony:
        "<ul>" +
        "<li><strong>Sceau d’Équiphase</strong> — source régulatrice de l’émanation</li>" +
        "<li><strong>Isqun</strong> — bande de fréquences potentielles à neuf pôles</li>" +
        "<li><strong>Threnisqun</strong> — densification opérative localisée du geste régulateur</li>" +
        "<li><strong>Takimarah</strong> — activation des modalités temporelles, dont <strong>Conscientisation dynamique</strong></li>" +
        "<li><strong>Tiqqunbahu</strong> — transformation des restes temporels en fragments recyclables</li>" +
        "<li><strong>Katûvýsqun</strong> — invocation possible dans un vortex d’alignement temporel</li>" +
        "<li><strong>Posœnnomia</strong> et <strong>Méditations posœnnoïales</strong> — harmonisation des cycles collectifs et ancrage dans le présent redistribué</li>" +
        "</ul>",

      cta_translate: "Proposer une traduction du concept"
    },

    en: {
      title: "Ēkuphasa",
      kicker: "Isqunian emanation of the <strong>Sceau d’Équiphase</strong> — spiral disintegration of excessive time.",
      title_img: { src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Ekuphasa_copie.png?v=1772922638", alt: "Ēkuphasa ideogram" },

      h_def: "Canonical definition",

      chip_1: "Threnisqun entity",
      chip_1_img: { src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/threnisqun_2_copie.png?v=1772883862", alt: "Threnisqun entity icon" },
      chip_2: "Frequency 619",
      chip_2_img: { src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Nombre_guide_619.png?v=1773414281", alt: "Frequency 619 icon" },
      chip_3: "Alignment 492 Hz",
      chip_3_img: { src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Nombre_guide_492.png?v=1773413365", alt: "Alignment 492 Hz icon" },

      def_short:
        "<strong>Ēkuphasa</strong> embodies the spiral disintegration of excessive time: it absorbs unintegrated temporal surplus, redistributes it as stabilizing breath, and makes the present breathable again.",

      def_long:
        "<p>An isqunian entity emanated from the <strong>Sceau d’Équiphase</strong>, <strong>Ēkuphasa</strong> works in the field of <strong>Threnisqun</strong> by transforming trapped time — delays, disjointed instants, cyclical residues, overload from the past or anticipation — into matter for rhythmic regeneration.</p>" +
        "<p>It does not correct time by constraint. It opens interstices, dissolves phase shifts, and restores a habitable cadence between lived time, social time, bodily rhythm, and cosmological respiration.</p>",

      h_grid: "Vibratory status",
      grid_type_label: "Nature",
      grid_type_value: "Isqunian entity issuing from the regulation of excessive time, emanated from the <strong>Sceau d’Équiphase</strong>.",
      grid_freq_label: "Alignment frequency",
      grid_freq_value: "619",
      grid_scope_label: "Field and deployment",
      grid_scope_value:
        "<ul>" +
        "<li>Lost time, unlived instants, cyclical residues, temporal layering</li>" +
        "<li>Liminal zones of the calendar: intercycles, epagomenal days, unwatched nights</li>" +
        "<li>Redistribution of surplus as stabilizing breath in the field</li>" +
        "<li>Re-attunement between human, social, and cosmological temporality</li>" +
        "</ul>",

      h_intro: "Main function",
      p_intro:
        "<p><strong>Ēkuphasa</strong> absorbs unintegrated temporal remains, disintegrates them through ritual spiralization, then redistributes them as breath. The decisive point of the corpus is here: time is not repaired, it is spiralized.</p>" +
        "<p>Its gesture protects the interstices of the living. When the past clogs the field, when the future weighs upon the present, when a cycle refuses to close or open, it restores a breathable field-condition.</p>",

      h_actions: "Ritual functions",
      actions:
        "<ol>" +
        "<li>Absorb temporal remains: lost hours, disjointed moments, unritualized absences.</li>" +
        "<li>Transform surplus into expansive breath rather than debt or correction.</li>" +
        "<li>Stabilize human temporality within the cosmological field.</li>" +
        "<li>Regulate dissonant cycles: linear time and lived time, social time and body time.</li>" +
        "<li>Preserve interstices by opening breathable thresholds in time.</li>" +
        "</ol>",

      h_phrase: "Usage formulas",
      phrase:
        "<p>“Ēkuphasa spiralizes.”</p>" +
        "<p>“Ēkuphasa redistributes.”</p>" +
        "<p>“Ēkuphasa opens the interstice.”</p>",

      h_table: "Usage table",
      table_head_1: "Situation",
      table_head_2: "Sign",
      table_head_3: "Action of Ēkuphasa",
      table_rows:
        "<tr><td>Overflowing time</td><td>Delay, layering, stratified feeling</td><td>Spiralizes surplus and makes it breathable</td></tr>" +
        "<tr><td>Clogged present</td><td>Past or future occupies all available space</td><td>Redistributes the load as stabilizing breath</td></tr>" +
        "<tr><td>Blocked cycle</td><td>Impossible to close or open a phase</td><td>Opens the temporal interstice</td></tr>" +
        "<tr><td>Dissonant temporalities</td><td>Social time against body rhythm</td><td>Re-attunes the field without forced correction</td></tr>",

      h_entite: "Name and operative breath",
      entite_kicker: "Ēku + phasa",
      entite_body:
        "<p>The corpus explains <strong>Ēkuphasa</strong> as “that which releases times trapped by breath.”</p>" +
        "<p><strong>Ēku-</strong> refers to spiral breath in the posœnnoïal lexicon; <strong>-phasa</strong> names the temporal fragment caught in entanglement. The name itself therefore carries a function of disentangling and redistributing through breath.</p>",

      h_ritual: "Activation ritual",
      ritual_name_label: "Name",
      ritual_name_value: "Souffle d’Ékuphase",
      ritual_steps:
        "<ol>" +
        "<li>Stand within an in-between moment: end of day, vigil, waiting, edge of cycle.</li>" +
        "<li>Recognize the overload of past time, delay, layering, or temporal dissociation.</li>" +
        "<li>Practice a silent spiral exhalation.</li>" +
        "<li>Visualize a black then silver breath rising from the heart toward the celestial space.</li>" +
        "<li>If needed, support the gesture with a gong or a three-part breath: 3–6–9 seconds.</li>" +
        "</ol>",

      h_moments: "Privileged moments",
      moments:
        "<ul>" +
        "<li>Between two cycles: months, years, days</li>" +
        "<li>During temporal suspension: delay, waiting, vigil</li>" +
        "<li>When the body feels an undigested excess of past time</li>" +
        "<li>In liminal calendar zones and intercycles</li>" +
        "</ul>",

      h_syntony: "Katûvýsian syntonies",
      syntony:
        "<ul>" +
        "<li><strong>Sceau d’Équiphase</strong> — regulating source of the emanation</li>" +
        "<li><strong>Isqun</strong> — nine-poled band of potential frequencies</li>" +
        "<li><strong>Threnisqun</strong> — localized operative densification of the regulating gesture</li>" +
        "<li><strong>Takimarah</strong> — activation of temporal modalities, including <strong>Conscientisation dynamique</strong></li>" +
        "<li><strong>Tiqqunbahu</strong> — transformation of temporal remains into recyclable fragments</li>" +
        "<li><strong>Katûvýsqun</strong> — may be invoked in a temporal alignment vortex</li>" +
        "<li><strong>Posœnnomia</strong> and <strong>Méditations posœnnoïales</strong> — harmonization of collective cycles and anchoring within redistributed presence</li>" +
        "</ul>",

      cta_translate: "Propose a translation of the concept"
    },

    es: {
      title: "Ēkuphasa",
      kicker: "Emanación isquniana del <strong>Sceau d’Équiphase</strong> — desintegración espiral del tiempo excedentario.",
      title_img: { src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Ekuphasa_copie.png?v=1772922638", alt: "Ideograma de Ēkuphasa" },

      h_def: "Definición canónica",

      chip_1: "Entidad Threnisqun",
      chip_1_img: { src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/threnisqun_2_copie.png?v=1772883862", alt: "Icono entidad Threnisqun" },
      chip_2: "Frecuencia 619",
      chip_2_img: { src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Nombre_guide_619.png?v=1773414281", alt: "Icono frecuencia 619" },
      chip_3: "Alineación 492 Hz",
      chip_3_img: { src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Nombre_guide_492.png?v=1773413365", alt: "Icono alineación 492 Hz" },

      def_short:
        "<strong>Ēkuphasa</strong> encarna la desintegración espiral del tiempo excedentario: absorbe el excedente temporal no integrado, lo redistribuye como aliento estabilizador y vuelve respirable el presente.",

      def_long:
        "<p>Entidad isquniana emanada del <strong>Sceau d’Équiphase</strong>, <strong>Ēkuphasa</strong> actúa en el campo de <strong>Threnisqun</strong> transformando el tiempo atrapado — retrasos, instantes disjuntos, residuos cíclicos, sobrecarga del pasado o de la anticipación — en materia de regeneración rítmica.</p>" +
        "<p>No corrige el tiempo por constricción. Abre intersticios, disuelve los desfases de fase y restituye una cadencia habitable entre tiempo vivido, tiempo social, ritmo del cuerpo y respiración cósmica.</p>",

      h_grid: "Estado vibratorio",
      grid_type_label: "Naturaleza",
      grid_type_value: "Entidad isquniana nacida de la regulación del tiempo excedentario, emanada del <strong>Sceau d’Équiphase</strong>.",
      grid_freq_label: "Frecuencia de alineación",
      grid_freq_value: "619",
      grid_scope_label: "Campo y despliegue",
      grid_scope_value:
        "<ul>" +
        "<li>Tiempo perdido, instantes no vividos, residuos cíclicos, estratificación temporal</li>" +
        "<li>Zonas liminares del calendario: interciclos, días epagómenos, noches sin vigilia</li>" +
        "<li>Redistribución del excedente como aliento estabilizador en el campo</li>" +
        "<li>Reajuste entre temporalidad humana, social y cósmica</li>" +
        "</ul>",

      h_intro: "Función principal",
      p_intro:
        "<p><strong>Ēkuphasa</strong> absorbe los restos temporales no integrados, los desintegra por espiralización ritual y luego los redistribuye como aliento. El punto decisivo del corpus está aquí: el tiempo no se repara, se espiraliza.</p>" +
        "<p>Su gesto protege los intersticios de lo viviente. Cuando el pasado obstruye, cuando el futuro pesa sobre el presente, cuando un ciclo rechaza cerrarse o abrirse, restituye al campo una respiración practicable.</p>",

      h_actions: "Funciones rituales",
      actions:
        "<ol>" +
        "<li>Absorber restos temporales: horas perdidas, momentos disjuntos, ausencias no ritualizadas.</li>" +
        "<li>Transformar el excedente en aliento expansivo, y no en deuda o corrección.</li>" +
        "<li>Estabilizar la temporalidad humana dentro del campo cósmico.</li>" +
        "<li>Regular ciclos disonantes: tiempo lineal y tiempo vivido, tiempo social y tiempo del cuerpo.</li>" +
        "<li>Preservar intersticios abriendo umbrales respirables en el tiempo.</li>" +
        "</ol>",

      h_phrase: "Fórmulas de uso",
      phrase:
        "<p>« Ēkuphasa spiraliza. »</p>" +
        "<p>« Ēkuphasa redistribuye. »</p>" +
        "<p>« Ēkuphasa abre el intersticio. »</p>",

      h_table: "Tabla de uso",
      table_head_1: "Situación",
      table_head_2: "Signo",
      table_head_3: "Acción de Ēkuphasa",
      table_rows:
        "<tr><td>Tiempo que desborda</td><td>Retraso, estratos, sensación de capas</td><td>Espiraliza el excedente y lo vuelve respirable</td></tr>" +
        "<tr><td>Presente saturado</td><td>Pasado o futuro ocupan todo el espacio</td><td>Redistribuye la carga como aliento estabilizador</td></tr>" +
        "<tr><td>Ciclo bloqueado</td><td>Imposibilidad de cerrar o abrir una fase</td><td>Abre el intersticio temporal</td></tr>" +
        "<tr><td>Temporalidades disonantes</td><td>Tiempo social contra ritmo del cuerpo</td><td>Reacuerda el campo sin corrección forzada</td></tr>",

      h_entite: "Nombre y aliento operante",
      entite_kicker: "Ēku + phasa",
      entite_body:
        "<p>El corpus explica <strong>Ēkuphasa</strong> como “lo que libera los tiempos atrapados por el aliento”.</p>" +
        "<p><strong>Ēku-</strong> remite al aliento espiral en el léxico posœnnoïal; <strong>-phasa</strong> nombra el fragmento temporal capturado en el enredo. El propio nombre porta así una función de desintricación y redistribución respiratoria.</p>",

      h_ritual: "Ritual de activación",
      ritual_name_label: "Nombre",
      ritual_name_value: "Souffle d’Ékuphase",
      ritual_steps:
        "<ol>" +
        "<li>Situarse en un entre-dos: final del día, vigilia, espera, borde de ciclo.</li>" +
        "<li>Reconocer el exceso de pasado, el retraso, la estratificación o la disociación temporal.</li>" +
        "<li>Practicar una exhalación silenciosa en espiral.</li>" +
        "<li>Visualizar un aliento negro y luego plateado que asciende del corazón al espacio celeste.</li>" +
        "<li>Si hace falta, sostener el gesto con un gong o un aliento en tres tiempos: 3–6–9 segundos.</li>" +
        "</ol>",

      h_moments: "Momentos privilegiados",
      moments:
        "<ul>" +
        "<li>Entre dos ciclos: meses, años, días</li>" +
        "<li>Durante una suspensión temporal: retraso, espera, vigilia</li>" +
        "<li>Cuando el cuerpo siente un exceso de pasado no digerido</li>" +
        "<li>En las zonas liminares del calendario y los interciclos</li>" +
        "</ul>",

      h_syntony: "Sintonías Katûvýsiennes",
      syntony:
        "<ul>" +
        "<li><strong>Sceau d’Équiphase</strong> — fuente reguladora de la emanación</li>" +
        "<li><strong>Isqun</strong> — banda de frecuencias potenciales de nueve polos</li>" +
        "<li><strong>Threnisqun</strong> — densificación operativa localizada del gesto regulador</li>" +
        "<li><strong>Takimarah</strong> — activación de modalidades temporales, incluida <strong>Conscientisation dynamique</strong></li>" +
        "<li><strong>Tiqqunbahu</strong> — transformación de los restos temporales en fragmentos reciclables</li>" +
        "<li><strong>Katûvýsqun</strong> — puede ser invocada en un vórtice de alineación temporal</li>" +
        "<li><strong>Posœnnomia</strong> y <strong>Méditations posœnnoïales</strong> — armonización de ciclos colectivos y anclaje en el presente redistribuido</li>" +
        "</ul>",

      cta_translate: "Proponer una traducción del concepto"
    }
  };

  function syncDocumentLang(lang) {
    try {
      document.documentElement.setAttribute("lang", lang || "fr");
    } catch (e) {}
  }

  function applyLangbar(root, lang) {
    var buttons = root.querySelectorAll("[data-po-lang]");
    for (var i = 0; i < buttons.length; i++) {
      var active = buttons[i].getAttribute("data-po-lang") === lang;
      buttons[i].setAttribute("aria-pressed", active ? "true" : "false");
      if (active) buttons[i].classList.add("is-active");
      else buttons[i].classList.remove("is-active");
    }
  }

  function applyContent(root, lang) {
    var c = CONTENT[lang] || CONTENT.fr;

    var htmlSlots = [
      "def_short", "def_long", "grid_type_value", "grid_scope_value", "p_intro", "actions", "phrase",
      "table_rows", "entite_body", "ritual_steps", "moments", "syntony", "kicker"
    ];

    var imgSlots = ["title_img", "chip_1_img", "chip_2_img", "chip_3_img"];

    var titleEl = root.querySelector('[data-po-slot="title"]');
    setText(titleEl, CONTENT.fr.title);

    Object.keys(c).forEach(function (key) {
      if (key === "title") return;
      var el = root.querySelector('[data-po-slot="' + key + '"]');
      if (!el) return;

      if (imgSlots.indexOf(key) > -1) {
        setImg(el, c[key]);
        return;
      }

      if (htmlSlots.indexOf(key) > -1) {
        setHTML(el, c[key]);
        return;
      }

      setText(el, c[key]);
    });

    applyLangbar(root, lang);
  }

  function lockTranslation(root) {
    if (!root) return;
    root.setAttribute("translate", "no");
    root.classList.add("notranslate");

    var scope = root.querySelector("[data-po-lex-scope]");
    if (scope) {
      scope.setAttribute("translate", "no");
      scope.classList.add("notranslate");
    }
  }

  function initOne(root, lang) {
    if (!root) return;
    lockTranslation(root);
    applyContent(root, lang || getLang());
  }

  function setLang(lang) {
    var safeLang = normLang(lang) || "fr";
    storeLang(safeLang);
    syncDocumentLang(safeLang);
    stopAudio(true);

    var roots = document.querySelectorAll(ROOT_SEL);
    for (var i = 0; i < roots.length; i++) {
      applyContent(roots[i], safeLang);
    }

    initAudioEverywhere(safeLang);
    notifyLocaleChanged();
    return safeLang;
  }

  function bindLangButtons(root) {
    var buttons = root.querySelectorAll("[data-po-lang]");
    for (var i = 0; i < buttons.length; i++) {
      (function (btn) {
        if (btn.__poLangBound) return;
        btn.addEventListener("click", function () {
          setLang(btn.getAttribute("data-po-lang"));
        });
        btn.__poLangBound = true;
      })(buttons[i]);
    }
  }

  function init() {
    var lang = getLang();
    syncDocumentLang(lang);
    var roots = document.querySelectorAll(ROOT_SEL);
    for (var i = 0; i < roots.length; i++) {
      initOne(roots[i], lang);
      bindLangButtons(roots[i]);
    }
    initAudioEverywhere(lang);
  }

  window.PoK5EkuphasaTextsFR_EN_ES_20260312 = {
    init: init,
    getLang: getLang,
    setLang: setLang,
    stopAudio: stopAudio
  };

  window.GoodyTwinLang = window.GoodyTwinLang || {};
  window.GoodyTwinLang.getLang = getLang;
  window.GoodyTwinLang.setLang = setLang;
  window.GoodyTwinLang.init = init;

  window.addEventListener("po:lexicon-ready", function () {
    __PO_PROTECT_RE__ = null;
    try { setLang(getLang()); } catch (e) {}
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
// JavaScript Document